import { AlertResponse } from './../../../../shared/alert/alertmessage';
import { PlannedOutagesResponse } from './../model/plannedoutagesresponse';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OutagesResponse } from '../model/outagesresponse';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { Subject, Observable } from 'rxjs';
import { OutagesFilterInfo } from '../model/outagesfilterinfo';
import { SurveyResponse } from '../../../../shared/alert/alertmessage';
import { tap } from 'rxjs/operators';

@Injectable()

export class OutagesService {

  private _outagesResultsCount = new Subject<number>();
  private _plannedOutagesResultsCount = new Subject<number>();

  constructor(public http: HttpClient) {

  }
  public getOutagesList(params: HttpParams): Observable<OutagesResponse> {
    let data = this.http.get<OutagesResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/outages', { params })
    .pipe(tap(resp => {
      this._outagesResultsCount.next(resp.resultCount);
    }));
    return data;
  }

  getPlannedOutagesList(params: HttpParams, plannedOutagesFilter: OutagesFilterInfo): Observable<PlannedOutagesResponse> {
    let plannedData = this.http.post<PlannedOutagesResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/plannedoutages', plannedOutagesFilter, { params })
    .pipe(tap(resp => {
      this._plannedOutagesResultsCount.next(resp.resultCount);
    }
    ));
    return plannedData;
  }
  public getItemCategories() {
    const params = new HttpParams()
      .set('itemOption', 'ALL');
    return this.http.get<ItemCategoriesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/allCategories', { params });
  }

  public getItemTypes() {
    const params = new HttpParams()
      .set('itemOption', 'ALL');
    return this.http.get<ItemTypesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
      '/customer/allItemTypes', { params });
  }

  public getAlertList() {
    let data = this.http.get<AlertResponse[]>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/alerts');
    return data;
}
  public getAlertDetails(_alertId: number): Observable<AlertResponse> {
    let data = this.http.get<AlertResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/alerts/' + _alertId);
    return data;
  }
public getSurveyList() {
  let data = this.http.get<SurveyResponse[]>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/surveys');
  return data;
}
  public getOutagesCount(): Observable<number> {
    return this._outagesResultsCount;
  }

  public getPlannedOutagesCount(): Observable<number> {
    return this._plannedOutagesResultsCount;
  }

}
